.Note {
  display: inline-flex;
  flex-direction: column;
  gap: 0.5rem;
  width: fit-content;

  padding: 1rem;
  border-radius: 0.5rem;
}
.Note[data-type="note"] {
  background-color: var(--color-note-background);
  color: var(--color-note);
}
.Note[data-type="quote"] {
  background-color: var(--color-quote-background);
  color: var(--color-quote);
}
.Note[data-type="warn"] {
  background-color: var(--color-warning-background);
  color: var(--color-warning);
}

.Header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: bold;
  line-height: 1;
}
.Note[data-type="note"] .Header {
  color: var(--color-note-header);
  font-size: 1.25rem;
}
.Note[data-type="quote"] .Header {
  color: var(--color-quote-header);
  font-size: 1.25rem;
}
.Note[data-type="warn"] .Header {
  color: var(--color-warning-header);
  font-size: 1.5rem;
}

.Icon {
  color: inherit;
}
.Note[data-type="note"] .Icon,
.Note[data-type="quote"] .Icon {
  height: 1.5rem !important;
  width: 1.5rem !important;
  flex: 0 0 1.5rem !important;
}
.Note[data-type="warn"] .Icon {
  height: 1.75rem !important;
  width: 1.75rem !important;
  flex: 0 0 1.75rem !important;
}

.Content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Content * {
  margin: 0;
}

.Note[data-type="note"] .Content,
.Note[data-type="quote"] .Content {
  line-height: 1rem;
  font-size: 1rem;
}
.Note[data-type="warn"] .Content {
  line-height: 1.25rem;
  font-size: 1.25rem;
}
